module.exports = __webpack_public_path__ + "img/bedroom-dressers.587b6bf.jpg";